import type { CaixaTransactionRow } from "./types";

const caixaBalanceFormatter = new Intl.NumberFormat("pt-BR", {
  maximumFractionDigits: 2,
});

export type CollapsedMobileTransactionTone = "credit" | "debit" | "undo";

export interface CollapsedMobileTransaction {
  reference: string;
  meta: string;
  amount: string;
  tone: CollapsedMobileTransactionTone;
}

export function formatCaixaBalance(value: number): string {
  return `${caixaBalanceFormatter.format(value)} cx`;
}

export function formatSignedCaixaBalance(value: number): string {
  const sign = value > 0 ? "+" : value < 0 ? "-" : "";
  return `${sign}${formatCaixaBalance(Math.abs(value))}`;
}

export function formatCaixaQuantity(row: CaixaTransactionRow): string {
  const sign = row.operation === "CREDIT" ? "+" : "-";
  return `${sign}${row.quantity} cx`;
}

export function getCaixaKindLabel(row: CaixaTransactionRow): string {
  if (row.kind === "undo") return "Desfazimento";
  if (row.kind === "linked" || row.checkin_id) return "Carga vinculada";
  return "Avulsa";
}

export function shouldShowUndoAction(row: CaixaTransactionRow): boolean {
  return (
    row.can_undo &&
    row.kind === "manual" &&
    !row.checkin_id &&
    !row.undone_by_transaction_id
  );
}

export function buildCollapsedMobileTransaction(
  row: CaixaTransactionRow,
): CollapsedMobileTransaction {
  const tone =
    row.kind === "undo"
      ? "undo"
      : row.operation === "CREDIT"
        ? "credit"
        : "debit";

  return {
    reference: getCaixaKindLabel(row),
    meta: row.actor_label,
    amount: formatCaixaQuantity(row),
    tone,
  };
}
